import { render, staticRenderFns } from "./Vm.vue?vue&type=template&id=88f953ce&"
import script from "./Vm.vue?vue&type=script&lang=js&"
export * from "./Vm.vue?vue&type=script&lang=js&"
import style0 from "./Vm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports